export default __webpack_public_path__ + "logo-google-play-it-c1d4ae79708dc3a3370047d8aed86ec3.svg";